import React from "react";
import Button from "../../../components/common/button/button";
import { IIconBasicProps } from "../../../assets/Icons/IIconBasicProps";
import { ItemCard } from "../ItemCard";
import { Item } from "../ez-quote.types";
import { useTranslation } from "../../../contexts/TranslationContext";

interface SummaryStepProps {
  items: Item[];
  maxItems: number;
  getIconComponent: (name: string | null) => React.FC<IIconBasicProps>;
  handleEditItem: (item: Item) => void;
  handleDeleteItem: (id: string) => void;
  handleAddItem: () => void;
  handleProceedToReview: () => void;
  openEstimateCard: boolean;
  setopenEstimateCard: (v: boolean) => void;
}

const SummaryStep: React.FC<SummaryStepProps> = ({
  items,
  maxItems,
  getIconComponent,
  handleEditItem,
  handleDeleteItem,
  handleAddItem,
  handleProceedToReview,
  openEstimateCard,
  setopenEstimateCard,
}) => {
  const t = useTranslation();
  const atMax = items.length >= maxItems;
  const remaining = maxItems - items.length;
  return (
    <div className="summary-container">
      <div className="summary-items">
        {items.map((item) => (
          <ItemCard
            key={item.id}
            item={item}
            getIconComponent={getIconComponent}
            onEdit={() => handleEditItem(item)}
            onDelete={() => handleDeleteItem(item.id)}
            setEstimateCard={() => setopenEstimateCard(!openEstimateCard)}
            openEstimateCardFlag={openEstimateCard}
          />
        ))}
      </div>
      <div className="summary-actions">
        <Button
          label={t.summary.addAnotherItem}
          onClick={atMax ? undefined : handleAddItem}
          styleType="secondary"
          disabled={atMax}
        />
        <p className="summary-items-remaining">
          {atMax
            ? t.summary.maxItems
            : <>{t.summary.canAddPre} <span className="remaining-count">{remaining} {t.summary.canAddMid(remaining)}</span> {t.summary.canAddPost}</>}
        </p>
        <Button
          label={t.summary.getMyQuote}
          onClick={handleProceedToReview}
          styleType="primary"
        />
      </div>
    </div>
  );
};

export default SummaryStep;
